import { render, staticRenderFns } from "./AdvancedForm.vue?vue&type=template&id=96c2fe08&scoped=true&"
import script from "./AdvancedForm.vue?vue&type=script&lang=js&"
export * from "./AdvancedForm.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedForm.vue?vue&type=style&index=0&id=96c2fe08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c2fe08",
  null
  
)

export default component.exports